import React from "react";
import styles from "./Input.module.scss";
import cn from "classnames";
import InputMask from 'react-input-mask';
import {Path, UseFormRegister, FieldValues} from "react-hook-form";

// Обобщение для поддержки различных типов
type InputProps<T extends FieldValues> = {
    label?: string;
    placeholder?: string;
    name: Path<T>;
    register: UseFormRegister<T>;
    required?: boolean;
    errorMessage?: string;
    mask?: string;
    value?: string | number;
    type?: string;
    className?: string;
};

const Input = <T extends FieldValues>(
    {
        label,
        placeholder,
        name,
        register,
        required,
        errorMessage,
        mask,
        value,
        type = 'text',  // по умолчанию text
        className
    }: InputProps<T>) => {
    const isCommentField = name === 'comment'; // Проверка для поля "comment"
    const isHiddenField = type === 'hidden';  // Проверка для скрытого поля

    // Функция для рендера поля ввода
    const renderInputField = () => {
        if (isHiddenField) {
            // Для скрытого поля пропускаем обертки div и label
            return (
                <input
                    id={name}
                    type="hidden"
                    value={value}
                    {...register(name, {required})}
                />
            );
        }

        if (isCommentField) {
            // Для поля "comment" возвращаем textarea
            return (
                <textarea
                    id={name}
                    className={styles.inputControl}
                    placeholder={placeholder}
                    value={value}
                    {...register(name, {required})}
                />
            );
        }

        if (mask) {
            // Если есть маска, используем InputMask
            return (
                <InputMask
                    id={name}
                    className={styles.inputControl}
                    placeholder={placeholder}
                    type={type}
                    mask={mask}
                    value={value}
                    {...register(name, {required})}
                />
            );
        }

        // Для обычного input
        return (
            <input
                id={name}
                className={styles.inputControl}
                placeholder={placeholder}
                type={type}
                value={value}
                {...register(name, {required})}
            />
        );
    };

    // Если поле скрыто, не рендерим div и label
    if (isHiddenField) {
        return renderInputField();
    }

    return (
        <div
            className={cn(
                styles.inputGroup,
                {[styles.inputError]: errorMessage},
                className && styles[className]
            )}
        >
            <label className={styles.inputLabel} htmlFor={name}>
                {label} {required && <span className={styles.required}>*</span>}
            </label>
            {renderInputField()}
            {errorMessage && <span className={styles.errorMessage}>{errorMessage}</span>}
        </div>
    );
};

export default Input;
